import { View } from "@/components/Theme/View";

export function tableParser(node, children, parent, styles, colorScheme) {
    return (
        <View mb={25} key={node.key} style={styles._VIEW_SAFE_table}>
            {children}
        </View>
    )
}